import { useQuery } from '@apollo/client';

import { MembersSearchDocument } from '../../graphql/queries/members-search-query.gql-types';

type UseSearchMemberParams = {
  text?: string;
  skip?: boolean;
  first?: number;
};
export const useSearchMember = ({
  text,
  skip = false,
  first = 50,
}: UseSearchMemberParams) => {
  return useQuery(MembersSearchDocument, {
    variables: {
      first,
      query: {
        consumer: 'loggedin.web.entitypages.search.react.search-results',
        queries: {
          name: text,
        },
      },
    },
    fetchPolicy: 'cache-first',
    skip,
  });
};
